var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "orderDetailDialog",
          attrs: { visible: _vm.linkProductVisible, width: "40%" },
          on: {
            "update:visible": function ($event) {
              _vm.linkProductVisible = $event
            },
          },
        },
        [
          _c("budget-detail", {
            attrs: {
              checkBudget: _vm.checkBudgetObj,
              chooseStockTypes: [_vm.budgetItem.state],
              planProductShowStatus: true,
              showCostPrice: true,
              showShaft: 1,
              linkProductFlag: true,
            },
            on: { deleteProduct: _vm.deleteProduct },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }